import { __decorate, __extends } from "tslib";
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { QBtn } from 'quasar';
import store from '../../../store';
var FormClickButton = /** @class */ (function (_super) {
    __extends(FormClickButton, _super);
    function FormClickButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FormClickButton.prototype, "isContinueAsOffer", {
        get: function () {
            return store.states.isContinueAsOffer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormClickButton.prototype, "isTabPanelSummary", {
        get: function () {
            return store.states.tabPanelName === 'summary';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormClickButton.prototype, "disable", {
        get: function () {
            // if (this.isTabPanelSummary) {
            return false;
            //   }
            //   return !this.isContinueAsOffer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormClickButton.prototype, "title", {
        get: function () {
            return this.props.title;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Inject()
    ], FormClickButton.prototype, "clickForm", void 0);
    __decorate([
        Prop({ required: true })
    ], FormClickButton.prototype, "formMetadata", void 0);
    __decorate([
        Prop({ required: true })
    ], FormClickButton.prototype, "props", void 0);
    FormClickButton = __decorate([
        Component({ components: { QBtn: QBtn } })
    ], FormClickButton);
    return FormClickButton;
}(Vue));
export default FormClickButton;
